<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    
          
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3> {{ mainTitle }} </h3>
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12" class="mt-1">
              <form-select
                rules="required"
                label="نوع التبرع"
                id="type_of_donation"
                v-model="form.type"
                :reduce="(x) => x.slug"
                :getOptionLabel="(x) => x.name"
                :options="[
                  {name : 'التبرع بعقار' , slug:'real_estates' } , 
                  {name : 'التبرع بمركبة' , slug:'machines'} 
                ]"
                
              />

            </b-col>
          </b-row>
          <b-row v-if="form.type === 'real_estates'">
            <b-col cols="12">
              <form-input
                v-model="form.number"
                rules="required"
                label="رقم العقار"
              />
              
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.equity_share"
                rules="required"
                label="الحصة السهمية"
              />

            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="نوع العقار"
                id="estate_type_id"
                v-model="form.estate_type_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/estate-types"
                
              />
              
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.region"
                rules="required"
                label="المنطقة الإدارية"
              />
              
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="المحافظة"
                id="governorate_id"
                v-model="form.governorate_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/governorates"
                
              />
              
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="صيغة التملك"
                id="possessive_form_id"
                v-model="form.possessive_form_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/possessive-forms"
                
              />
              
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="موضوع بالخدمة"
                id="is_operating"
                v-model="form.is_operating"
                :reduce="(x) => x.value"
                :getOptionLabel="(x) => x.text"
                :options="[
                  {
                    text: 'نعم',
                    value: 1,
                  },
                  {
                    text: 'لا',
                    value: 0,
                  },
                ]" 
                
              />
              
            </b-col>

            <b-col cols="12">
              <form-file-input
                placeholder="اختر ملفاً"
                id="estate_document"
                accept=".doc,.pdf,.docx"
                v-model="form.estate_document"
                label="وثيقة العقار"
                rules="required"
              />
            </b-col>

          </b-row>
          <b-row v-if="form.type === 'machines'">
            <b-col cols="12">
              <form-select
                rules="required"
                label="نوع المركبة"
                id="machine_type_id"
                v-model="form.machine_type_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/machine-types"
                
              />
              
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.model"
                rules="required"
                label="الطراز"
              />
              
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.plate_number"
                rules="required"
                label="رقم اللوحة"
              />
              
            </b-col>

            <b-col cols="12">
              <form-select
                rules="required"
                label="محافظة التسجيل"
                id="governorate_id"
                v-model="form.governorate_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/governorates"
                
              />
              
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.serial_number"
                rules="required"
                label="الرقم التسلسلي"
              />
              
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.structure_no"
                rules="required"
                label="رقم الهيكل"
              />
              
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.engine_number"
                rules="required"
                label="رقم المحرك"
              />
              
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.color"
                rules="required"
                label="اللون"
              />
              
            </b-col>
            <b-col cols="12">
              <form-select
                label="سنة الصنع"
                id="year"
                :options="getYears()"
                rules="required"
                v-model="form.year"
              />
              
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="نوع الوقود"
                id="fuel_type_id"
                v-model="form.fuel_type_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/fuel-types"
                
              />
              
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.passengers_number"
                rules="required|integer|min:1|max:2"
                label="عدد الركاب"
              />
              
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="صيغة التملك"
                id="machine_possessive_form_id"
                v-model="form.possessive_form_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/possessive-forms"
                
              />
              
            </b-col>
            <b-col cols="12">
              <form-file-input
                placeholder="اختر ملفاً"
                id="document"
                label="وثيقة الملكية"
                accept=".doc,.pdf,.docx"
                v-model="form.ownership_doc"
                rules="required"
              />

            </b-col>

            <b-col cols="12">
             
              <b-form-checkbox class="my-1 mx-50" v-model="form.tax">
                معفاة من الضرائب
              </b-form-checkbox>
            </b-col>

          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  BFormCheckbox
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput ,
    BFormCheckbox
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "بياناتت المعاملة",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    type_of_donation(){
      return this.form.type|| null
    }
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
    type_of_donation(val){
      if(val==='machines'){
        if (this.form.hasOwnProperty('number')) {
          delete this.form['number'];
        }
        
        if (this.form.hasOwnProperty('estate_type_id')) {
          delete this.form['estate_type_id'];
        }
        
        if (this.form.hasOwnProperty('region')) {
          delete this.form['region'];
        }
        
        if (this.form.hasOwnProperty('governorate_id')) {
          delete this.form['governorate_id'];
        }
        
        if (this.form.hasOwnProperty('possessive_form_id')) {
          delete this.form['possessive_form_id'];
        }
        
        if (this.form.hasOwnProperty('is_operating')) {
          delete this.form['is_operating'];
        }
        
        if (this.form.hasOwnProperty('estate_document')) {
          delete this.form['estate_document'];
        }

      }
      else{
        if (this.form.hasOwnProperty('machine_type_id')) {
          delete this.form['machine_type_id'];
        }
        
        if (this.form.hasOwnProperty('model')) {
          delete this.form['model'];
        }
        
        if (this.form.hasOwnProperty('plate_number')) {
          delete this.form['plate_number'];
        }
        
        if (this.form.hasOwnProperty('governorate_id')) {
          delete this.form['governorate_id'];
        }
        
        if (this.form.hasOwnProperty('serial_number')) {
          delete this.form['serial_number'];
        }
        
        if (this.form.hasOwnProperty('structure_no')) {
          delete this.form['structure_no'];
        }
        
        if (this.form.hasOwnProperty('fuel_type')) {
          delete this.form['fuel_type'];
        }
        
        if (this.form.hasOwnProperty('passengers_number')) {
          delete this.form['passengers_number'];
        }
        
        if (this.form.hasOwnProperty('possessive_form_id')) {
          delete this.form['possessive_form_id'];
        }
        
        if (this.form.hasOwnProperty('ownership_doc')) {
          delete this.form['ownership_doc'];
        }
        
        if (this.form.hasOwnProperty('tax')) {
          delete this.form['tax'];
        }

      }


    }
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    getYears() {
      var x = [];
      for (let index = 1900; index < this.$moment().year(); index++) {
        x.push(`${index}`);
      }
      return x.reverse();
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          if(this.form.type === 'machines')
          {
            if (this.form.hasOwnProperty('tax') && this.form.tax === true) {
                this.form.tax = 1
              }
              else{
                this.form.tax = 0
              }
          }
          
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
